import { Suspense, ReactNode } from "react";

import { GlobalErrorBoundary } from "./ErrorBoundary";
import { useLoadingMessages } from '../hooks/useLoadingMessages';

interface SuspenseWithErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
  errorFallback?: ReactNode;
}

export function SuspenseWithErrorBoundary({
  children,
  fallback,
  errorFallback,
}: SuspenseWithErrorBoundaryProps) {
  const msg = useLoadingMessages();
  const defaultFallback = fallback || <div>{msg.loading}</div>;

  return (
    <GlobalErrorBoundary fallback={errorFallback}>
      <Suspense fallback={defaultFallback}>
        {children}
      </Suspense>
    </GlobalErrorBoundary>
  );
}